/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isEmpty } from 'lodash';

// Components
import AssetPreview from 'shared/ui/components/uploader/AssetPreview.vue';
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import FileDropper from 'shared/ui/components/form-components/pickers/FileDropper.vue';
import UploadProgress from 'shared/ui/components/uploader/UploadProgress.vue';

// Constants
const WorkerType = window.SharedWorker ? SharedWorker : Worker;

// Mixins
import uploader from './uploader';
import workerStarter from './worker-starter';

const __vue_script__ = {
    name: 'CloudStorageFileUploader',

    components: { AssetPreview, FileDropper, UploadProgress },

    extends: BaseControl,

    mixins: [uploader, workerStarter],

    props: {
        scope: {
            type: String,
            required: true
        },

        maxSize: {
            type: Number,
            default: Math.pow(8, 8)
        },

        value: {
            type: [File, FileList, Object],
            default: null
        },

        multiple: {
            type: Boolean,
            default: true
        },

        attachmentName: {
            type: String,
            default: null
        },

        showPreview: {
            type: Boolean,
            default: true
        },

        worker: {
            type: WorkerType,
            default: null
        },
    },

    data() {
        return {
            handler: null,
            metadata: null
        };
    },

    computed: {
        showAssetPreview() {
            return !this.stillUploading && this.value instanceof Object && this.$utils.attachments.hasAnyAttachments(this.value);
        },

        showFileDropper() {
            return isEmpty(this.value?.fp_attachments_s3) && !this.stillUploading;
        },

        supportedMimes() {
            const mimes = this.attachmentSpecs.allowed_content_types || [];

            if (isEmpty(mimes)) {
                console.warn('[CloudStorageFileUploader] The requested upload mime types do not match with the metadata of the fpType', this.fpType);
            }

            return mimes;
        },

        attachmentSpecs() {
            return this.$utils.metadata.getAttachmentSpecs(this.metadata, this.maxSize);
        }
    },

    async created() {
        try {
            const eid = this.event.id || this.event._id;
            this.metadata = await this.$services.metadata.getMetadataForType(eid, this.fpType);
        } catch (error) {
            console.error('[CloudStorageFileUploader] Could not determine qualified content types for fpType', this.fpType, error);
        }
    },

    mounted() {
        this.initWorker();
    },

    beforeDestroy() {
        if (this.workerScope) {
            this.workerScope.removeEventListener('message', this.handleWorkerMessage);
        }

        this.terminate('destroy');
    },

    methods: {

        /**
         * Method called once the upload is completed by the uploader mixin
         *
         * @param {object} response the worker message response
         */
        onUploaded(response) {
            console.debug('[CloudStorageFileUploader] Upload dispatched to the worker (file may not be ready yet; completion status available on signal)', response);
            this.$refs['dropper'].clear();
            const results = response.results;
            // Only get files that have been successfully uploaded
            const files = (results || []).filter(f => f?.status === 200);

            if (isEmpty(files)) {
                console.debug('[CloudStorageFileUploader] No files have been uploaded');
            }

            this.reset();
        },

        promptDeletion() {
            this.$modal.show('dialog', {
                title: this.$t('general.confirm_prompt'),
                text: this.$t('general.deletion_confirmation'),
                buttons: [
                    {
                        title: this.$t('general.dismiss'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.confirm'),
                        handler: async () => {
                            await this.deleteAsset();
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        async deleteAsset() {
            try {
                const eid = this.event.id || this.event._id;
                if (this.attachmentName) {
                    await this.$services.documents.deleteAttachment(eid, this.assetId, this.attachmentName);
                } else {
                    await this.$services.documents.deleteDocs(eid, this.event.node, this.fpType, [this.assetId]);
                }

                this.uploads = this.uploads.filter((u) => {
                    return !(u.id === this.assetId && u.scope === this.scope && u.event_id === eid);
                });
                this.$refs['dropper'].clear();

                this.$emit('deleted');
            } catch (error) {
                console.error('[CloudStorageFileUploader] Could not delete asset', error);
            }
        },

        onCompleted(result, doc) {
            const event_id = this.event.id || this.event._id;
            this.workerScope.postMessage({ event_id, command: 'info', scope: this.scope });
            this.decreaseCounters(result);

            this.$emit('input', doc);
            this.$emit('uploaded', doc);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      staticClass: "cloud-storage-file-uploader",
      attrs: {
        label: _vm.label,
        tip: _vm.tip,
        hint: _vm.showAssetPreview ? null : _vm.hint,
        uid: _vm.uid,
        errors: _vm.errors,
        warning: _vm.warning,
        dependant: _vm.dependant,
      },
    },
    [
      _vm.showAssetPreview
        ? [
            _c("div", { staticClass: "toolbar" }, [
              _vm.assetId
                ? _c(
                    "button",
                    {
                      staticClass:
                        "delete btn btn-danger btn-mini single btn-icon",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.promptDeletion()
                        },
                      },
                    },
                    [_c("i", { staticClass: "ic-trash" })]
                  )
                : _vm._e(),
            ]),
            _vm.showPreview
              ? _c("asset-preview", {
                  attrs: { asset: _vm.value, event: _vm.event },
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.supportedMimes.length
        ? _c("file-dropper", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showFileDropper,
                expression: "showFileDropper",
              },
            ],
            ref: "dropper",
            attrs: {
              "supported-mimes": _vm.supportedMimes,
              "max-size": _vm.maxSize,
              "attachment-specs": _vm.attachmentSpecs,
              multiple: _vm.multiple,
            },
            on: { input: _vm.startUpload },
          })
        : _vm._e(),
      _vm.uploads.length && !_vm.showAssetPreview
        ? _c("section", { staticClass: "uploads" }, [
            _vm.activeUploads > 1
              ? _c("div", { staticClass: "batch-actions" }, [
                  _c(
                    "a",
                    {
                      staticClass: "has-action",
                      on: {
                        click: function ($event) {
                          return _vm.abort()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("media.uploads.cancel_all")))]
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "items" },
              _vm._l(_vm.uploads, function (upload) {
                return _c("upload-progress", {
                  key: upload.id,
                  attrs: {
                    upload: upload,
                    "worker-scope": _vm.workerScope,
                    "fp-type": _vm.fpType,
                  },
                  on: {
                    progress: function ($event) {
                      return _vm.setStarted()
                    },
                    started: function ($event) {
                      return _vm.increaseCounters()
                    },
                    canceled: function ($event) {
                      return _vm.decreaseCounters()
                    },
                    completed: _vm.onCompleted,
                    error: function ($event) {
                      return _vm.decreaseAndShowError()
                    },
                    abort: function ($event) {
                      return _vm.abort(upload)
                    },
                  },
                })
              }),
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/uploader/CloudStorageFileUploader.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__